<div class="datagrid-paging {{ classList }}">
	<div class="datagrid-page-number" *ngIf="settings.options.hasPaging">
		<span class="datagrid-paging-label" translate="Pagination.PageNumberLabel"> </span>

		<pagination
			[directionLinks]="false"
			[totalItems]="list.totalCount"
			[itemsPerPage]="list.pageSize"
			[maxSize]="20"
			[rotate]="false"
			[page]="settings.pageNumber"
			(pageChanged)="onPageNumberChange($event.page)"
		>
		</pagination>

		<pager
			[totalItems]="list.totalCount"
			[itemsPerPage]="list.pageSize"
			[page]="settings.pageNumber"
			(pageChanged)="onPageNumberChange($event.page)"
			firstText="{{ 'Pagination.First' | translate }}"
			lastText="{{ 'Pagination.Last' | translate }}"
			nextText="&rsaquo;"
			previousText="&lsaquo;"
		>
		</pager>
	</div>

	<div class="datagrid-page-size" *ngIf="settings.options.hasPageSize">
		<span class="datagrid-paging-label" translate="Pagination.PageSizeLabel"> </span>
		<label [for]="'taillePageSelect' + attributeId"></label>
		<select
			[id]="'taillePageSelect' + attributeId"
			aria-label="Choisir la taille de la page"
			[ngModel]="settings.pageSize"
			(ngModelChange)="onPageSizeChange($event)"
		>
			<option *ngFor="let size of settings.options.availablePageSizes" [ngValue]="size">
				{{ size }}
			</option>
		</select>
	</div>
</div>
